import agency_contact_config from "@/components/AgencyContact/config";

export default {
  singleLabel: "Agence",
  storeNamespace: 'agency',
  authFeature: 'agency',
  listRouteName: "AgencyList",
  newRouteName: "AgencyNew",
  editRouteName: "AgencyEdit",
  detailRouteName: "AgencyDetail",
  useNewModal: true,
  useEditModal: true,
  formComponentName: 'AgencyForm',
  hideActionCsvButton: true,
  hideActionPdfButton: true,
  titleField: 'name',
  sortBy: 'name',
  fields: [{
      name: 'name',
      label: "Nom",
      type: 'text',
      inForm: true,
      required: true,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: false,
    },
    {
      name: 'internal_number',
      label: "Code interne",
      type: 'text',
      inForm: true,
      required: true,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
    },
    {
      name: 'agency_group_id',
      label: "Groupe d'agences",
      type: 'select',
      inForm: true,
      required: false,
      inList: false,
      inDetail: false,
    },
    {
      name: 'agency_group',
      label: "Groupe d'agences",
      type: 'select',
      inForm: false,
      inList: true,
      sortable: true,
      filterIn: true,
      formatter: (context, value, item) => item ? item.agency_group_name : null
    },
    {
      name: 'agency_group',
      label: "Groupe d'agences",
      inDetail: true,
      formatter: (context, value) => value ? value.name : null
    },
    {
      name: 'agency_contacts',
      label: "Contacts",
      type: 'group_repeater',
      inForm: true,
      required: false,
      fields: [{
        name: 'email',
        label: "Email du contact",
        type: 'email',
        required: true,
      }]
    },
    {
      name: 'agency_contacts',
      label: "Contacts",
      type: 'list',
      icone: 'id-card',
      config: agency_contact_config,
      fields: ['email']
    },
    {
      name: 'created_at',
      label: "Création",
      type: 'date',
      inForm: false,
      inList: false,
      inDetail: false,
      formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
    },
    {
      name: 'updated_at',
      label: "Dernière modification",
      type: 'date',
      inForm: false,
      inList: false,
      inDetail: false,
      formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
    },
    {
      name: 'businesses',
      label: "Affaires",
      type: 'text',
      inDetail: true,
      formatter: (context, value) => value ? value : 0
    },
    {
      name: 'employees',
      label: "Employés",
      type: 'text',
      inDetail: true,
      formatter: (context, value) => value ? value : 0
    },
    {
      name: 'rentings',
      label: "Commandes",
      type: 'text',
      inDetail: true,
      formatter: (context, value) => value ? value : 0
    },
    {
      name: 'business_returns',
      label: "Retours",
      type: 'text',
      inDetail: true,
      formatter: (context, value) => value ? value : 0
    },
    {
      name: 'transfers',
      label: "Transferts",
      type: 'text',
      inDetail: true,
      formatter: (context, value) => value ? value : 0
    },
    {
      name: 'manual_billings',
      label: "Factures manuelles",
      type: 'text',
      inDetail: true,
      formatter: (context, value) => value ? value : 0
    },
    {
      name: 'internal_billing_lines',
      label: "Factures automatiques",
      type: 'text',
      inDetail: true,
      formatter: (context, value) => value ? value : 0
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/Agency/config.js